import { useForumItineraryMeetingFacilitiesQuery } from "api/queries/forumItinerary";
import { useGetForumByIdQuery } from "api/queries/forums";
import MobileLinkList, { LinkListProp } from "components/MobileLinkList";
import { Grid, SpinLoading } from "components/styleguide/mobile";
import FacilityType from "enums/FacilityType";
import { MeetingFacilityModel } from "generated/api";
import { toNumber } from "lodash-es";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext, useParams } from "react-router-dom";

import { PlaybookOutletContext } from "../types";

export default function PlaybookMeetings() {
  const { t } = useTranslation();
  const { setTitle, setTitle2 } = useOutletContext<PlaybookOutletContext>();
  const forumId = toNumber(useParams().id);
  setTitle(t("Meetings"));

  const { data: { data: facilities = [] } = {}, isLoading } = useForumItineraryMeetingFacilitiesQuery({ forumId });
  const { data: { data: forum = {} } = {}, isLoading: isLoadingForum } = useGetForumByIdQuery({ forumId });

  useEffect(() => {
    if (isLoadingForum || !forum?.title) {
      setTitle(t("Loading..."));
    } else {
      setTitle(forum.title);
    }
    setTitle2(null);
  }, [forum.title, isLoadingForum]);

  if (!facilities || isLoading) {
    return (
      <div className="loader">
        <SpinLoading style={{ "--size": "48px" }} />
      </div>
    );
  }

  return (
    <Grid columns={2} gap={8}>
      <MobileLinkList
        items={facilities?.map((f: MeetingFacilityModel) => {
          return {
            id: f.id.toString(),
            title: f.name,
            link: `facilities/${f.buildingId}/${f.id}`,
            footerTextLeft: f.code,
            footerTextMiddle: t(FacilityType.toDisplayName(FacilityType.fromApiFacilityType(f.facilityType))),
          } as LinkListProp;
        })}
      />
    </Grid>
  );
}
